const getCardResponse = (rawData: any) => {
  const result = rawData?.data?.data[0]
  const transformedData: ResponseType = result?.metric?.map(
    (value: string, index: number) => {
      return {
        metric: value,
        visits: result.visits[index] ? result.visits[index][0] : 0,
        visitors: result.visitors[index] ? result.visitors[index][0] : 0,
        contributors: result.contributors[index]
          ? result.contributors[index][0]
          : 0,
        contributions: result.contributions[index]
          ? result.contributions[index][0]
          : 0,
      }
    },
  )
  return {
    data: transformedData,
    info: rawData?.data?.meta?.info,
  }
}

const activityOverTimeFormattedResponses = {
  getCardResponse,
}

export default activityOverTimeFormattedResponses
